import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import '../../scss/controls/_iconbutton.scss';

export enum IconButtonTheme {
    White = 'white',
    Red = 'red',
    Blue = 'blue',
    DarkBlueActive = 'darkblue',
    Transparent = 'transparent',
    TransparentRed = 'transparent-red',
}

export enum IconButtonSize {
    /** 28px: sits beside a compact (36px) input. */
    ExtraSmall = 'extraSmall',
    Small = 'small',
    Medium = 'medium',
}

export const IconButton: React.FC<{
    id: string;
    theme: IconButtonTheme;
    size: IconButtonSize;
    disabled?: boolean;
    icon: IconDefinition;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    bubbleNumber?: number;
}> = ({ id, theme, handleClick, size, icon, hint, bubbleNumber, disabled }) => {
    const [buttonClicked, set_buttonClicked] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);
    const setStyle = {
        cursor: `${disabled ? 'arrow' : 'pointer'}`,
    };

    const onClick = (event: React.MouseEvent) => {
        if (!buttonClicked) {
            set_buttonClicked(true);
            if (handleClick) {
                handleClick(event);
            }
        } else {
            set_buttonClicked(false);
        }
    };

    // Detect outside click
    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                set_buttonClicked(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div
                ref={buttonRef}
                id={id}
                className={`iconButton ${theme} ${size} ${disabled ? 'disabled' : ''} ${buttonClicked ? 'selected' : 'unselected'}`}
                style={setStyle}
                onClick={!disabled ? onClick : undefined}
                title={hint}
            >
                <FontAwesomeIcon
                    icon={icon}
                    className='iconButton-image'
                />
                {bubbleNumber != undefined && bubbleNumber > 0 && (
                    <div className={`iconButton-bubble`}>{bubbleNumber > 99 ? '99+' : bubbleNumber}</div>
                )}
            </div>
        </>
    );
};
